import _ from 'lodash';

export const renderEnum = (e: string | undefined): string => _.startCase(_.toLower(e));
